import { Bell } from "lucide-react";
import { Avatar } from "@/components/Avatar";
import { formateazaRON } from "@/lib/settlement";

// Tab-ul „Balanțe": soldul fiecărui membru (are de primit / are de dat / e chit).
export function BalancesTab({ group, user, solduri, onNotify }) {
  return (
    <div className="space-y-3">
      {group.members.map((m) => {
        const sold = solduri[m.id] || 0;
        const pozitiv = sold > 0.01;
        const negativ = sold < -0.01;
        return (
          <div
            key={m.id}
            data-testid={`balance-item-${m.id}`}
            className={`bg-white rounded-2xl border shadow-sm p-4 flex items-center gap-3 ${
              m.userId === user?.user_id ? "border-emerald-400 ring-1 ring-emerald-300" : "border-slate-100"
            }`}
          >
            <Avatar name={m.name} />
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-slate-900 truncate">
                {m.name}
                {m.userId === user?.user_id && <span className="text-emerald-600"> (tu)</span>}
              </p>
              <p className="text-xs text-slate-500 mt-0.5">
                {pozitiv && "Are de primit"}
                {negativ && "Are de dat"}
                {!pozitiv && !negativ && "E chit"}
              </p>
            </div>
            <p
              className={`font-heading font-extrabold ${
                pozitiv ? "text-emerald-600" : negativ ? "text-rose-500" : "text-slate-400"
              }`}
            >
              {pozitiv && "+"}
              {formateazaRON(sold)}
            </p>
            {negativ && (
              <button
                data-testid={`notify-member-${m.id}`}
                aria-label={`Anunță pe ${m.name}`}
                onClick={() => onNotify(m, sold)}
                className="shrink-0 h-9 w-9 flex items-center justify-center rounded-full bg-rose-50 text-rose-500 hover:bg-rose-100 transition-colors"
                title="Anunță pe WhatsApp"
              >
                <Bell className="h-4 w-4" strokeWidth={2.5} />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
